<template>
  <div class="container main-area">
    <div class="row">
      <div class="col-md-12">
        <h1 class="centered">Начальный уровень</h1>
        <br>
        <h3>Программа курса составляет  472 ак. часов (8 месяцев)</h3>
        <span>Курс состоит из трех модулей </span>
        <ul class="course-list list-group">
          <li class="list-group-item">
            <strong>1. Обзорная экскурсия по Санкт-Петербургу</strong> - 230 ак. ч.<br>
            (октябрь 2025 – январь 2026) 
          </li>
          <li class="list-group-item">
            <strong>2. Трассовые экскурсии: Петергоф, Пушкин и Павловск</strong> - 152 ак.ч.<br>
            (февраль 2026 – апрель 2026) 
          </li>
          <li class="list-group-item">
            <strong>3. Кронштадт: трасса и обзорная по городу</strong> <br>
            (апрель 2026 – май 2026)
          </li>
        </ul>
        <br>
        <div class="enroll-btn">
          <router-link class="btn btn-success btn-md btn-block" :to="{name: 'OnlineEnrollment'}">Записаться</router-link>
        </div>
        <br>
        <h3>Продолжительность курса</h3>
        <ul>
          <li>с 02.10.24 по 21.05.26</li>
          <li>
            472 ак. часа, в том числе 
            <ul>
              <li>7 учебных экскурсий (3 пешеходных, 4 автобусных)</li>
              <li>3 зачетные экскурсии</li>
              <li>самостоятельная работа с дополнительным методическим материалом</li>
			  <li>o	работа на экскурсионном тренажере.</li>
            </ul>
          </li>
        </ul>
        <h3>Занятия</h3>
        <ul>
          <li>вторник, четверг с 19:00 до 22:00</li>
          <li>пешеходные, учебные и зачетные экскурсии по выходным.</li>
        </ul>
        <h3>Стоимость</h3>
        <ul>
          <li>за весь курс – 69 000 руб.; при единовременной оплате скидка 5% – 65 550 руб.</li>
          <li>возможна помесячная оплата:</li>
        </ul>
        <b-table
          responsive
          bordered
          striped
          :fields="fields"
          :items="items"
        />
        <div class="enroll-btn">
          <router-link class="btn btn-success btn-md btn-block" :to="{name: 'OnlineEnrollment'}">Записаться</router-link>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { entryLvlCourseCost } from '@/data'

export default {
  data () {
    return {
      items: entryLvlCourseCost,
      fields: {
        paymentPeriod: {
          class: 'centered align-middle',
          label: 'Сроки оплаты'
        },
        month: {
          class: 'centered align-middle',
          label: 'За месяц'
        },
        paymentMonth: {
          class: 'centered align-middle',
          label: 'Сумма в рублях <br> за месяц'
        }
      }
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style>
  .enroll-btn {
    max-width: 200px;
    margin: 0 auto;
  }
</style>



// WEBPACK FOOTER //
// CoursesEntry.vue?14e73d91